import { UnorderedListOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import React from 'react';

interface IGantButtonListOfTask {
    onClick: () => void;
    title?: string;
}

const GantButtonListOfTask: React.FC<IGantButtonListOfTask> = ({ onClick, title }) => {
    return (
        <Tooltip title={'Click to see list of task'}>
            <Button icon={<UnorderedListOutlined />} type={'default'} onClick={onClick}>
                {title}
            </Button>
        </Tooltip>
    );
};

export default React.memo(GantButtonListOfTask);
